import { apiClient } from './client'
import type { ProcurementQueueItem, ClientCategory, RequestItemPriority } from './types'

interface QueueQuery {
  assignedToMe?: boolean
  overdue?: boolean
  burning?: boolean
  stale?: boolean
  needsInfo?: boolean
  rework?: boolean
  clientCategory?: ClientCategory
  priority?: RequestItemPriority
  q?: string
  cursor?: string
  limit?: number
  // Серверные фильтры «дашборд РОЗ → очередь» (13.07, композиты — 16.07).
  procState?: string
  new?: boolean
  zeroPrice?: boolean
  wentToInvoice?: boolean
  noOffer?: boolean
  inWork?: boolean
  noAnswer?: boolean
  activeOnly?: boolean
  buyerId?: string
  requestType?: 'TEKUCHKA' | 'PROJECT'
  // Режим «Показать скрытые» (ADMIN/ГД) — вернуть свои скрытые позиции.
  showHidden?: boolean
}

export interface ProcurementQueuePage {
  items: ProcurementQueueItem[]
  hasMore: boolean
  nextCursor: string | null
  // Сколько позиций скрыто у текущего пользователя (0 для ролей без скрытия).
  hiddenCount: number
  // true → роль может скрывать позиции (ADMIN/GENERAL_DIRECTOR).
  canHide: boolean
  // Страховка №319: серверная выборка очереди упёрлась в потолок — показаны не
  // все позиции. limit — этот потолок, а не размер страницы.
  truncated?: boolean
  limit?: number
}

export async function getProcurementQueue(query: QueueQuery = {}): Promise<ProcurementQueuePage> {
  const res = await apiClient.get<{ success: true; data: ProcurementQueuePage }>(
    '/procurement/queue',
    { params: query },
  )
  return res.data.data
}

/** Скрыть позиции у себя (ADMIN/ГД). Возвращает число реально скрытых. */
export async function hideQueueItems(itemIds: string[]): Promise<{ hidden: number }> {
  const res = await apiClient.post<{ success: true; data: { hidden: number } }>(
    '/procurement/queue/hide',
    { itemIds },
  )
  return res.data.data
}

/** Вернуть скрытые позиции (пустой itemIds → все). */
export async function unhideQueueItems(itemIds?: string[]): Promise<{ restored: number }> {
  const res = await apiClient.post<{ success: true; data: { restored: number } }>(
    '/procurement/queue/unhide',
    itemIds && itemIds.length > 0 ? { itemIds } : {},
  )
  return res.data.data
}
